(function() {
  var STORAGE_KEY = 'realleader_attribution_v1';
  var EXPIRY_DAYS = 90;
  var EXPIRY_MS = EXPIRY_DAYS * 24 * 60 * 60 * 1000;
  var TEXT_MAX = 250;
  var URL_MAX = 500;
  var CONSENT_CAPTURE_RETRY_MS = 250;
  var CONSENT_CAPTURE_RETRY_LIMIT = 40;
  var ATTRIBUTION_READY_EVENT = 'realleader:attribution-ready';
  var NATIVE_SUBMIT_GUARD_SELECTOR = 'form[data-rl-native-submit-guard]';
  var consentCaptureRetryActive = false;
  var attributionReadyNotified = false;
  var privacyApiReady = false;
  var helperDataClearedForDenial = false;
  var UTM_MAP = {
    utm_source: 'source',
    utm_medium: 'medium',
    utm_campaign: 'campaign',
    utm_content: 'content',
    utm_term: 'term'
  };
  var CONTACT_FIELDS = [
    'first_touch_source',
    'first_touch_medium',
    'first_touch_campaign',
    'first_touch_content',
    'first_touch_term',
    'last_touch_source',
    'last_touch_medium',
    'last_touch_campaign',
    'last_touch_content',
    'last_touch_term',
    'first_landing_page',
    'last_landing_page',
    'meta_click_id'
  ];
  var QUOTE_EVENT_FIELDS = [
    'product_id',
    'variant_id',
    'product_handle',
    'quantity',
    'quote_item_count',
    'product_range',
    'page_location'
  ];
  var LEAD_EVENT_FIELDS = CONTACT_FIELDS.concat([
    'enquiry_type',
    'product_range',
    'quote_item_count',
    'page_location'
  ]);

  function customerPrivacy() {
    try {
      return window.Shopify && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null;
    } catch (error) {
      return null;
    }
  }

  function permissionState(privacy, methodName) {
    try {
      if (!privacy || typeof privacy[methodName] !== 'function') {
        return 'unknown';
      }
      var value = privacy[methodName]();
      if (value === true) return 'granted';
      if (value === false) return 'denied';
      return 'unknown';
    } catch (error) {
      return 'unknown';
    }
  }

  function storageConsentState() {
    if (!privacyApiReady) return 'unknown';
    var privacy = customerPrivacy();
    var analyticsState = permissionState(privacy, 'analyticsProcessingAllowed');
    var marketingState = permissionState(privacy, 'marketingAllowed');
    if (analyticsState === 'unknown' || marketingState === 'unknown') return 'unknown';
    return analyticsState === 'granted' && marketingState === 'granted' ? 'granted' : 'denied';
  }

  function hasStorageConsent() {
    return storageConsentState() === 'granted';
  }

  function sanitizeText(value, maxLength) {
    if (value === null || value === undefined) {
      return '';
    }
    var text = String(value).replace(/[\u0000-\u001f\u007f]/g, ' ').trim();
    if (/[<>]|javascript:|data:text\/html|on[a-z]+\s*=|script/i.test(text)) {
      return '';
    }
    return text.slice(0, maxLength || TEXT_MAX);
  }

  function landingPage() {
    var origin = window.location.origin || (window.location.protocol + '//' + window.location.host);
    return sanitizeText(origin + window.location.pathname, URL_MAX);
  }

  function nowIso() {
    return new Date().toISOString();
  }

  function blankContactFieldValues() {
    var fields = {};
    CONTACT_FIELDS.forEach(function(field) {
      fields[field] = '';
    });
    return fields;
  }

  function blankContactForm(form) {
    if (!form) {
      return;
    }
    CONTACT_FIELDS.forEach(function(field) {
      var input = form.querySelector('[data-rl-attribution-field="' + field + '"]');
      if (input) {
        input.value = '';
      }
    });
  }

  function clearContactFields() {
    try {
      document.querySelectorAll('[data-rl-attribution-contact-form]').forEach(blankContactForm);
    } catch (error) {
      return false;
    }
    return true;
  }

  function clearHelperData() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      // Storage can be unavailable in privacy-restricted contexts.
    }
    clearContactFields();
  }

  function ensureStorageConsent() {
    var state = storageConsentState();
    if (state === 'denied') {
      if (!helperDataClearedForDenial) {
        clearHelperData();
        helperDataClearedForDenial = true;
      }
      attributionReadyNotified = false;
      return false;
    }
    if (state !== 'granted') return false;
    helperDataClearedForDenial = false;
    return true;
  }

  function readStore() {
    if (!ensureStorageConsent()) {
      return {};
    }
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) {
        return {};
      }
      var parsed = JSON.parse(raw);
      if (!parsed || parsed.expires_at < Date.now()) {
        window.localStorage.removeItem(STORAGE_KEY);
        return {};
      }
      return parsed;
    } catch (error) {
      return {};
    }
  }

  function writeStore(data) {
    if (!ensureStorageConsent()) {
      return false;
    }
    try {
      data.expires_at = Date.now() + EXPIRY_MS;
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      return true;
    } catch (error) {
      return false;
    }
  }

  function captureCurrentAttribution() {
    if (!ensureStorageConsent()) {
      return {};
    }
    var data = readStore();
    var params = new URLSearchParams(window.location.search || '');
    var captured = {};
    var hasRecognisedAttribution = false;

    Object.keys(UTM_MAP).forEach(function(param) {
      var value = sanitizeText(params.get(param), TEXT_MAX);
      if (value) {
        captured[UTM_MAP[param]] = value;
        hasRecognisedAttribution = true;
      }
    });

    var fbclid = sanitizeText(params.get('fbclid'), TEXT_MAX);
    if (fbclid) {
      data.meta_click_id = fbclid;
      hasRecognisedAttribution = true;
    }

    if (!data.first_landing_page) {
      data.first_landing_page = landingPage();
      data.first_touch_timestamp = nowIso();
    }

    if (hasRecognisedAttribution) {
      Object.keys(captured).forEach(function(key) {
        if (!data['first_touch_' + key]) {
          data['first_touch_' + key] = captured[key];
        }
        data['last_touch_' + key] = captured[key];
      });
      data.last_landing_page = landingPage();
      data.last_touch_timestamp = nowIso();
    } else if (!data.last_landing_page) {
      data.last_landing_page = data.first_landing_page;
      data.last_touch_timestamp = data.first_touch_timestamp || nowIso();
    }

    writeStore(data);
    return data;
  }

  function getContactFields() {
    if (!ensureStorageConsent()) {
      return blankContactFieldValues();
    }
    var data = readStore();
    var fields = {};
    CONTACT_FIELDS.forEach(function(field) {
      fields[field] = sanitizeText(data[field], field.indexOf('landing_page') !== -1 ? URL_MAX : TEXT_MAX);
    });
    return fields;
  }

  function writeContactFields(form) {
    if (!form) {
      return;
    }
    if (!ensureStorageConsent()) {
      blankContactForm(form);
      return;
    }
    var fields = getContactFields();
    CONTACT_FIELDS.forEach(function(field) {
      var input = form.querySelector('[data-rl-attribution-field="' + field + '"]');
      if (input) {
        input.value = fields[field] || '';
      }
    });
  }

  function getFormValue(form, name) {
    var field = form && form.querySelector('[name="' + name + '"]');
    if (!field) {
      return '';
    }
    return field.value || '';
  }

  function pageLocation() {
    return landingPage();
  }

  function buildQuotePayload(form, cart) {
    var quantity = parseInt(getFormValue(form, 'quantity'), 10);
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    return {
      product_id: sanitizeText(form && form.getAttribute('data-rlm-product-id'), TEXT_MAX),
      variant_id: sanitizeText(getFormValue(form, 'id'), TEXT_MAX),
      product_handle: sanitizeText(form && form.getAttribute('data-rlm-product-handle'), TEXT_MAX),
      quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
      quote_item_count: count >= 0 ? count : 0,
      product_range: sanitizeText(form && form.getAttribute('data-rlm-product-range'), TEXT_MAX),
      page_location: pageLocation()
    };
  }

  function filterPayload(payload, allowedFields) {
    var safe = {};
    allowedFields.forEach(function(field) {
      if (!Object.prototype.hasOwnProperty.call(payload || {}, field)) {
        return;
      }
      if (field === 'quantity' || field === 'quote_item_count') {
        var numberValue = parseInt(payload[field], 10);
        safe[field] = Number.isFinite(numberValue) && numberValue >= 0 ? numberValue : 0;
        return;
      }
      safe[field] = sanitizeText(payload[field], field.indexOf('page') !== -1 ? URL_MAX : TEXT_MAX);
    });
    return safe;
  }

  function publishEvent(eventName, payload) {
    if (!ensureStorageConsent()) {
      return false;
    }
    var allowedFields = eventName === 'realleader:lead_submitted' ? LEAD_EVENT_FIELDS : QUOTE_EVENT_FIELDS;
    var safePayload = filterPayload(payload, allowedFields);
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, safePayload);
        return true;
      }
      if (window.analytics && typeof window.analytics.publish === 'function') {
        window.analytics.publish(eventName, safePayload);
        return true;
      }
    } catch (error) {
      return false;
    }
    return false;
  }

  function bindContactForms() {
    document.querySelectorAll('[data-rl-attribution-contact-form]').forEach(writeContactFields);
  }

  function setNativeSubmitGuard(form, submitter) {
    form.setAttribute('data-rl-native-submit-in-flight', 'true');
    form.setAttribute('aria-busy', 'true');
    if (!submitter || submitter.disabled) return;

    submitter.setAttribute('data-rl-native-submit-made-disabled', 'true');
    submitter.setAttribute('data-rl-native-submit-idle-label', (submitter.textContent || '').trim());
    submitter.disabled = true;
    submitter.textContent = form.getAttribute('data-rl-native-submit-busy-label') || 'Sending…';
  }

  function resetNativeSubmitGuards() {
    document.querySelectorAll(NATIVE_SUBMIT_GUARD_SELECTOR).forEach(function(form) {
      form.removeAttribute('data-rl-native-submit-in-flight');
      form.removeAttribute('aria-busy');
      form.querySelectorAll('[data-rl-native-submit-made-disabled="true"]').forEach(function(submitter) {
        var idleLabel = submitter.getAttribute('data-rl-native-submit-idle-label');
        submitter.disabled = false;
        if (idleLabel) submitter.textContent = idleLabel;
        submitter.removeAttribute('data-rl-native-submit-made-disabled');
        submitter.removeAttribute('data-rl-native-submit-idle-label');
      });
    });
  }

  function eventPublisherReady() {
    try {
      return !!(
        (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') ||
        (window.analytics && typeof window.analytics.publish === 'function')
      );
    } catch (error) {
      return false;
    }
  }

  function notifyAttributionReady() {
    if (attributionReadyNotified) {
      return true;
    }
    if (!hasStorageConsent() || !eventPublisherReady()) {
      return false;
    }
    attributionReadyNotified = true;
    try {
      document.dispatchEvent(new CustomEvent(ATTRIBUTION_READY_EVENT, {
        detail: { version: 'phase-h-3' }
      }));
    } catch (error) {
      attributionReadyNotified = false;
      return false;
    }
    return true;
  }

  function handleConsentUpdate() {
    var state = storageConsentState();
    if (state === 'denied') {
      ensureStorageConsent();
      return;
    }
    if (state !== 'granted') {
      return;
    }
    captureCurrentAttribution();
    bindContactForms();
    notifyAttributionReady();
  }

  function scheduleConsentCaptureRetry() {
    if (consentCaptureRetryActive || typeof window.setTimeout !== 'function') {
      return;
    }
    consentCaptureRetryActive = true;
    var attempts = 0;
    function retryConsentCapture() {
      attempts += 1;
      var state = storageConsentState();
      if (state === 'denied') {
        ensureStorageConsent();
        consentCaptureRetryActive = false;
        return;
      }
      if (state === 'granted' && ensureStorageConsent()) {
        captureCurrentAttribution();
        bindContactForms();
        if (notifyAttributionReady()) {
          consentCaptureRetryActive = false;
          return;
        }
      }
      if (attempts >= CONSENT_CAPTURE_RETRY_LIMIT) {
        consentCaptureRetryActive = false;
        return;
      }
      window.setTimeout(retryConsentCapture, CONSENT_CAPTURE_RETRY_MS);
    }
    window.setTimeout(retryConsentCapture, CONSENT_CAPTURE_RETRY_MS);
  }

  function loadCustomerPrivacyApi() {
    try {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
        return false;
      }
      window.Shopify.loadFeatures([
        {
          name: 'consent-tracking-api',
          version: '0.1'
        }
      ], function(error) {
        if (error) {
          return;
        }
        privacyApiReady = true;
        handleConsentUpdate();
        scheduleConsentCaptureRetry();
      });
      return true;
    } catch (error) {
      return false;
    }
  }

  document.addEventListener('submit', function(event) {
    var form = event.target.closest('[data-rl-attribution-contact-form]');
    if (form) {
      writeContactFields(form);
    }
  }, true);

  document.addEventListener('submit', function(event) {
    var form = event.target.closest && event.target.closest(NATIVE_SUBMIT_GUARD_SELECTOR);
    if (!form) return;
    if (form.getAttribute('data-rl-native-submit-in-flight') === 'true') {
      event.preventDefault();
      return;
    }

    var submitter = event.submitter || form.querySelector('button[type="submit"], input[type="submit"]');
    setNativeSubmitGuard(form, submitter);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindContactForms);
  } else {
    bindContactForms();
  }

  window.addEventListener('pageshow', function(event) {
    if (event && event.persisted === true) resetNativeSubmitGuards();
    bindContactForms();
    notifyAttributionReady();
    scheduleConsentCaptureRetry();
  });
  window.addEventListener('load', scheduleConsentCaptureRetry, { once: true });
  document.addEventListener('visitorConsentCollected', function() {
    privacyApiReady = true;
    handleConsentUpdate();
    scheduleConsentCaptureRetry();
  });

  window.RealleaderAttribution = {
    version: 'phase-h-3',
    capture: captureCurrentAttribution,
    getContactFields: getContactFields,
    writeContactFields: writeContactFields,
    buildQuotePayload: buildQuotePayload,
    publishEvent: publishEvent,
    _test: {
      storageKey: STORAGE_KEY,
      sanitizeText: sanitizeText,
      storageConsentState: storageConsentState,
      hasStorageConsent: hasStorageConsent,
      clearHelperData: clearHelperData,
      handleConsentUpdate: handleConsentUpdate,
      notifyAttributionReady: notifyAttributionReady,
      loadCustomerPrivacyApi: loadCustomerPrivacyApi,
      scheduleConsentCaptureRetry: scheduleConsentCaptureRetry,
      resetNativeSubmitGuards: resetNativeSubmitGuards,
      markPrivacyApiReady: function() {
        privacyApiReady = true;
      }
    }
  };

  captureCurrentAttribution();
  loadCustomerPrivacyApi();
  scheduleConsentCaptureRetry();
})();
